(function () {
    'use strict';

    angular.module("imApp").factory("bankReconciliationsBtGetHistoryModalService", ['$ihttp', function ($ihttp) {
        let service = {
            getHistory: function (parms) {
                return $ihttp.post({
                    method: 3407,
                    parameters: parms || {}
                });
            },
            executeObj: function (history) {
                return $ihttp.post({
                    method: 3408,
                    parameters: history
                });
            }
        };

        return service;
    }]);
})();
